import CenteredSpinner from "@/components/CenteredSpinner";
import EmailView from "@/components/mailsList/EmailView";
import SmartLabelIcon from "@/components/SmartLabelIcon";
import SmartLabel from "@/domain/enums/SmartLabel";
import useGetMailsList from "@/hooks/mails/useGetMailsList";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const ViewTitle = ({ title }: { title: SmartLabel }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="text-left">
                <h2 className="text-main-title flex w-full items-center justify-start gap-2 truncate text-start font-display text-3xl">
                    <span className="shrink-0">
                        <SmartLabelIcon smartLabel={title} />
                    </span>
                    <span className="truncate">
                        {t(`emails.headers.smartLabels.${title}.title`)}
                    </span>
                </h2>
                {i18n.exists(
                    `emails.headers.smartLabels.${title}.description`,
                ) && (
                    <p className="hidden text-sm xl:block">
                        {t(`emails.headers.smartLabels.${title}.description`)}
                    </p>
                )}
            </div>
            <hr className="my-2" />
        </>
    );
};

const SmartLabelEmails = () => {
    const location = useLocation();
    const pathSmartLabel = location.pathname.split("/").pop() as SmartLabel;
    const navigate = useNavigate();

    if (!Object.values(SmartLabel).includes(pathSmartLabel)) {
        navigate("/404");
    }

    const {
        isLoading: isLoadingMails,
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        flattenedMails,
        updateVersion,
    } = useGetMailsList(pathSmartLabel);

    const { data: userProfile, isLoading: isUserProfileLoading } =
        useGetUserProfile();

    if (!userProfile || isUserProfileLoading) {
        return <CenteredSpinner />;
    }

    return (
        <EmailView
            displayMode={
                userProfile.settings.displayPreferences.emailDisplayMode
            }
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoadingMails}
            listId={pathSmartLabel}
            loadNextPage={fetchNextPage}
            mails={flattenedMails}
            title={<ViewTitle title={pathSmartLabel} />}
            updateVersion={updateVersion}
        />
    );
};

export default SmartLabelEmails;
